/*                                                                                                                                                                                                                                                                                                                                               
EEEEEEEEEEEEEEEEEEEEEE                                        iiii                                                                      tttt                                                                                   lllllll                                    PPPPPPPPPPPPPPPPP                                                     
E::::::::::::::::::::E                                       i::::i                                                                  ttt:::t                                                                                   l:::::l                                    P::::::::::::::::P                                                    
E::::::::::::::::::::E                                        iiii                                                                   t:::::t                                                                                   l:::::l                                    P::::::PPPPPP:::::P                                                   
EE::::::EEEEEEEEE::::E                                                                                                               t:::::t                                                                                   l:::::l                                    PP:::::P     P:::::P                                                  
  E:::::E       EEEEEE   qqqqqqqqq   qqqqquuuuuu    uuuuuu  iiiiiiirrrrr   rrrrrrrrr       eeeeeeeeeeee        ccccccccccccccccttttttt:::::ttttttt      aaaaaaaaaaaaa  nnnn  nnnnnnnn       ggggggggg   ggggguuuuuu    uuuuuu   l::::l   aaaaaaaaaaaaa  rrrrr   rrrrrrrrr   P::::P     P:::::Paaaaaaaaaaaaa  nnnn  nnnnnnnn       ooooooooooo   
  E:::::E               q:::::::::qqq::::qu::::u    u::::u  i:::::ir::::rrr:::::::::r    ee::::::::::::ee    cc:::::::::::::::ct:::::::::::::::::t      a::::::::::::a n:::nn::::::::nn    g:::::::::ggg::::gu::::u    u::::u   l::::l   a::::::::::::a r::::rrr:::::::::r  P::::P     P:::::Pa::::::::::::a n:::nn::::::::nn   oo:::::::::::oo 
  E::::::EEEEEEEEEE    q:::::::::::::::::qu::::u    u::::u   i::::ir:::::::::::::::::r  e::::::eeeee:::::ee c:::::::::::::::::ct:::::::::::::::::t      aaaaaaaaa:::::an::::::::::::::nn  g:::::::::::::::::gu::::u    u::::u   l::::l   aaaaaaaaa:::::ar:::::::::::::::::r P::::PPPPPP:::::P aaaaaaaaa:::::an::::::::::::::nn o:::::::::::::::o
  E:::::::::::::::E   q::::::qqqqq::::::qqu::::u    u::::u   i::::irr::::::rrrrr::::::re::::::e     e:::::ec:::::::cccccc:::::ctttttt:::::::tttttt               a::::ann:::::::::::::::ng::::::ggggg::::::ggu::::u    u::::u   l::::l            a::::arr::::::rrrrr::::::rP:::::::::::::PP           a::::ann:::::::::::::::no:::::ooooo:::::o
  E:::::::::::::::E   q:::::q     q:::::q u::::u    u::::u   i::::i r:::::r     r:::::re:::::::eeeee::::::ec::::::c     ccccccc      t:::::t              aaaaaaa:::::a  n:::::nnnn:::::ng:::::g     g:::::g u::::u    u::::u   l::::l     aaaaaaa:::::a r:::::r     r:::::rP::::PPPPPPPPP      aaaaaaa:::::a  n:::::nnnn:::::no::::o     o::::o
  E::::::EEEEEEEEEE   q:::::q     q:::::q u::::u    u::::u   i::::i r:::::r     rrrrrrre:::::::::::::::::e c:::::c                   t:::::t            aa::::::::::::a  n::::n    n::::ng:::::g     g:::::g u::::u    u::::u   l::::l   aa::::::::::::a r:::::r     rrrrrrrP::::P            aa::::::::::::a  n::::n    n::::no::::o     o::::o
  E:::::E             q:::::q     q:::::q u::::u    u::::u   i::::i r:::::r            e::::::eeeeeeeeeee  c:::::c                   t:::::t           a::::aaaa::::::a  n::::n    n::::ng:::::g     g:::::g u::::u    u::::u   l::::l  a::::aaaa::::::a r:::::r            P::::P           a::::aaaa::::::a  n::::n    n::::no::::o     o::::o
  E:::::E       EEEEEEq::::::q    q:::::q u:::::uuuu:::::u   i::::i r:::::r            e:::::::e           c::::::c     ccccccc      t:::::t    tttttta::::a    a:::::a  n::::n    n::::ng::::::g    g:::::g u:::::uuuu:::::u   l::::l a::::a    a:::::a r:::::r            P::::P          a::::a    a:::::a  n::::n    n::::no::::o     o::::o
EE::::::EEEEEEEE:::::Eq:::::::qqqqq:::::q u:::::::::::::::uui::::::ir:::::r            e::::::::e          c:::::::cccccc:::::c      t::::::tttt:::::ta::::a    a:::::a  n::::n    n::::ng:::::::ggggg:::::g u:::::::::::::::uul::::::la::::a    a:::::a r:::::r          PP::::::PP        a::::a    a:::::a  n::::n    n::::no:::::ooooo:::::o
E::::::::::::::::::::E q::::::::::::::::q  u:::::::::::::::ui::::::ir:::::r             e::::::::eeeeeeee   c:::::::::::::::::c      tt::::::::::::::ta:::::aaaa::::::a  n::::n    n::::n g::::::::::::::::g  u:::::::::::::::ul::::::la:::::aaaa::::::a r:::::r          P::::::::P        a:::::aaaa::::::a  n::::n    n::::no:::::::::::::::o
E::::::::::::::::::::E  qq::::::::::::::q   uu::::::::uu:::ui::::::ir:::::r              ee:::::::::::::e    cc:::::::::::::::c        tt:::::::::::tt a::::::::::aa:::a n::::n    n::::n  gg::::::::::::::g   uu::::::::uu:::ul::::::l a::::::::::aa:::ar:::::r          P::::::::P         a::::::::::aa:::a n::::n    n::::n oo:::::::::::oo 
EEEEEEEEEEEEEEEEEEEEEE    qqqqqqqq::::::q     uuuuuuuu  uuuuiiiiiiiirrrrrrr                eeeeeeeeeeeeee      cccccccccccccccc          ttttttttttt    aaaaaaaaaa  aaaa nnnnnn    nnnnnn    gggggggg::::::g     uuuuuuuu  uuuullllllll  aaaaaaaaaa  aaaarrrrrrr          PPPPPPPPPP          aaaaaaaaaa  aaaa nnnnnn    nnnnnn   ooooooooooo   
                                  q:::::q                                                                                                                                                            g:::::g                                                                                                                                    
                                  q:::::q                                                                                                                                                gggggg      g:::::g                                                                                                                                    
                                 q:::::::q                                                                                                                                               g:::::gg   gg:::::g                                                                                                                                    
                                 q:::::::q                                                                                                                                                g::::::ggg:::::::g                                                                                                                                    
                                 q:::::::q                                                                                                                                                 gg:::::::::::::g                                                                                                                                     
                                 qqqqqqqqq                                                                                                                                                       gggggg                                                                                                                                                                                                                                     
*/

import { getEventEmitter } from './PanoPlayer'
const Panorama = require('./Panorama').default
const CanvasManager = require('./CanvasManager.js').default

const fireEvent = function(eventName, player) {
    let eventEmitter = getEventEmitter()
    if (eventName == 'viewReady' && player.viewReadyFired) {
        return
    }

    var event = document.createEvent('HTMLEvents')
    event.initEvent(eventName, true, true)

    event.eventName = eventName

    player.elem.dispatchEvent(event)
    if (eventName == 'viewReady') {
        player.viewReadyFired = true
    }
    eventEmitter.emit(eventName, null)
}

export default function EquirectangularPanorama() {
    Panorama.apply(this, arguments)

    this.panoPlayer = arguments[0]

    // this.rootType = PanoPlayer.types.EQUIRECTANGULAR
    this.rootType = 'equirectangular'

    this.element = CanvasManager.getCanvas()
    this.renderer = new THREE.WebGLRenderer({ antialias: true, canvas: this.element })

    this.createEquiMesh = () => {
        // use calculate zoom level to get the file size
        var fileName =
            this.panoPlayer.zoomLevels[this.panoPlayer.calculateZoom(EquirectangularPanorama.allowedZooms)] + '.jpg'
        var texture = this.player.options.texture
        if (!texture) {
            texture = new THREE.TextureLoader().load(this.getTileUrl(), function() {
                fireEvent('viewReady', _this.player)
                _this.needsRefresh = true
            })
        } else {
            fireEvent('viewReady', this.player)
        }

        var _this = this,
            hqSphere = new THREE.Mesh(
                new THREE.SphereGeometry(this.player.viewerWidth * 4, 64, 32),
                new THREE.MeshBasicMaterial({
                    map: texture,
                    overdraw: true,
                    transparent: true,
                    side: THREE.BackSide,
                })
            )
        hqSphere.scale.x = -1

        this.hqSphereIndex = this.meshes.length
        this.meshes.push(hqSphere)
    }

    this.createBusinessCard = text => {
        if (!text) {
            return
        }

        var width = 420,
            height = 170,
            canvas = document.createElement('canvas'),
            context = canvas.getContext('2d'),
            cTexture = new THREE.Texture(canvas),
            card = new THREE.Mesh(
                new THREE.PlaneGeometry(width, height),
                new THREE.MeshBasicMaterial({
                    map: cTexture,
                    color: 0xffffffff,
                })
            ),
            fontSize = 20

        canvas.width = width
        canvas.height = height

        context.fillStyle = 'rgba(255,255,255,0.7)'
        context.fillRect(0, 0, canvas.width, canvas.height)
        context.font = fontSize + 'px Arial'
        context.fillStyle = 'rgb(0,0,0)'
        context.textAlign = 'center'

        text = text.split('\n')

        var margin = (height - fontSize * text.length) / (text.length + 1),
            hIndex = margin + 45 //not 100% why this is necessary but otherwise its too near the top

        for (var i in text) {
            context.fillText(text[i], width / 2, hIndex)
            hIndex += fontSize + margin
        }

        cTexture.needsUpdate = true

        card.rotation.x = -Math.PI / 2
        card.position.setY(-500)

        this.meshes.push(card)
    }

    this.createEquiMesh()

    this.createBusinessCard(this.player.options.businessCard)

    // we only need to load one image, so let's just do that
    this.loadedImage = () => {
        this.needsRefresh = true

        if (!this.player.viewReadyFired) {
            fireEvent('viewReady', this.player)
        }
        fireEvent('panoLoaded', this.player)
    }

    this.regenerateTextures = () => {
        var _this = this

        for (var mI in this.meshes) {
            this.meshes[mI].visible = false
        }

        this.createEquiMesh()
    }

    this._getTileUrl = function(path, size, coord) {
        return originCacheBuster(path + size + '.jpg')
    }

    // this.destroy = () => {
    //     this.destroy.call(this)

    // // we need to free texture image resources to prevent memory leaking
    // for (var i = 0; i < this.meshes.length; i++) {
    //     var mesh = this.meshes[i]

    //     // if the material is a basic material, it will only have one material to clean up
    //     if (mesh.material.type == 'MeshBasicMaterial') {
    //         mesh.material.map.dispose()

    //         // otherwise, clean em all up
    //     } else {
    //         for (var m = 0; m < mesh.material.length; m++) {
    //             var mat = mesh.material[m]

    //             //this.renderer.deallocateTexture(mat.map);
    //             mat.map.dispose()
    //         } //next m
    //     } //endif
    // } //next i
    // }
}
